import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.admin-status-update-modal.yes",
	description:"yes",
	defaultMessage:"UPDATE"
    },
    
    no:{
	id:"app.admin-status-update-modal.no",
	description:"no",
	defaultMessage:"No"
    },

    statusUpdate:{
	id:"app.admin-status-update-modal.status",
	description:"Update Status",
	defaultMessage:"Update Status"
    },

    reason:{
	id:"app.admin-status-update-modal.reason-limit",
	description:"reason",
	defaultMessage:"Reason ( Max 100 Chars )"
    }
});

export default messages;
